import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import {PanelItem} from '../../../components'
import Typography from 'material-ui/Typography'
import IconButton from 'material-ui/IconButton'
import CloseIcon from 'material-ui-icons/Close'

const styles = theme => ({
  Image: {
    objectFit: 'scale-down',
  },
})

const FlowItemPanelWithCross = ({classes, imgSrc, name, description, price, onClick}) => (
  <PanelItem>
    <IconButton onClick={onClick} style={{height: 24, width: 24, marginRight: 16}}><CloseIcon style={{height: 16, width: 16}}/></IconButton>
    <img
      src={imgSrc}
      alt={name}
      className={classes.Image}
      width={43} height={43}
    />
    <div style={{display: 'flex', flex: 1, paddingLeft: 16}}>
      <div style={{flex: 1}}>
        <Typography variant={'body2'}>{name}</Typography>
        <Typography variant={'body1'} color={'textSecondary'}>{description}</Typography>
      </div>
      <div>
        <Typography variant={'body2'} color={'primary'} style={{marginTop: 20}}>{price}</Typography>
      </div>
    </div>
  </PanelItem>
)

FlowItemPanelWithCross.propTypes = {
  imgSrc: PropTypes.string,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  price: PropTypes.string,
  isButton: PropTypes.bool,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

FlowItemPanelWithCross.defaultProps = {
  imgSrc: '/assets/imagen_no_disponible.png',
  isButton: false,
  onClick: () => {},
  disabled: false,
}

export default withStyles(styles, {withTheme: true})(FlowItemPanelWithCross)



// WEBPACK FOOTER //
// ./src/sections/flow/components/flowItemPanelWithCross.jsx